import React, {FC} from 'react';
import styled from 'styled-components';

import {UnreachableError} from '../../../../../../libs/shared/helpers/src/types/customErrors';
import {CommentUnfurlModel, CommentUnfurlTypesEnum} from '../../../../../models/api/commentUnfurlModel';
import {NewPanelId} from '../../../../../store/panels/panelStateBase';
import {CommentViewerConversationUnfurlContainer} from './commentViewerConversationUnfurlContainer';
import {CommentViewerTopicUnfurlContainer} from './commentViewerTopicUnfurlContainer';

/*
 * Props.
 */

interface CommentViewerUnfurlsProps {
  panelId: NewPanelId;
  conversationId: number;
  unfurls: ReadonlyArray<CommentUnfurlModel>;
  isInteractionDisabled?: boolean;
}

/*
 * Styles.
 */

export const StyledCommentViewerUnfurlsContainer = styled.div``;

/*
 * Component.
 */

export const CommentViewerUnfurls: FC<CommentViewerUnfurlsProps> = (props) => {
  if (props.unfurls.length === 0) {
    return null;
  }

  const unfurlRenders = props.unfurls.slice(0, 3).map((unfurl) => renderUnfurl(unfurl, props));

  return <StyledCommentViewerUnfurlsContainer>{unfurlRenders}</StyledCommentViewerUnfurlsContainer>;
};

/*
 * Helpers.
 */

function renderUnfurl(unfurl: CommentUnfurlModel, props: CommentViewerUnfurlsProps) {
  switch (unfurl.type) {
    case CommentUnfurlTypesEnum.CONVERSATION:
    case CommentUnfurlTypesEnum.MESSAGE:
      return (
        <CommentViewerConversationUnfurlContainer
          key={unfurl.token}
          unfurl={unfurl}
          panelId={props.panelId}
          conversationId={props.conversationId}
          isInteractionDisabled={props.isInteractionDisabled}
        />
      );

    case CommentUnfurlTypesEnum.TOPIC:
      return (
        <CommentViewerTopicUnfurlContainer
          key={unfurl.token}
          unfurl={unfurl}
          isInteractionDisabled={props.isInteractionDisabled}
        />
      );

    default:
      throw new UnreachableError(unfurl);
  }
}
